<template>
  <div class="admin">
    <!-- Mientras Firebase resuelve si hay sesion admin persistida, no
         mostramos ni el login ni el panel (evita flash y evita exponer
         contenido protegido por un instante). -->
    <div v-if="!authReady" class="admin__auth-loading">
      <div class="lds-dual-ring"></div>
    </div>
    <template v-else>
      <div class="ovelay" v-if="!authenticated">
        <Auth @loggedIn="getLoginInfo" />
      </div>
      <router-view v-if="authenticated" />
    </template>
  </div>
</template>

<script>
import firebase from "../firebase.service";
import Auth from "./admin/Auth";
export default {
  metaInfo: {
    title: "Admin",
  },
  components: {
    Auth
  },
  data() {
    return {
      // authenticated arranca en FALSE: el ingreso al admin exige login con
      // contrasena (Firebase Auth, email admin@...). Antes estaba forzado en
      // `true`, lo que dejaba TODO el panel (y datos de clientes) accesible
      // sin autenticar.
      authenticated: false,
      // authReady = ya resolvio el primer onAuthStateChanged.
      authReady: false
    };
  },
  created() {
    // Derivamos la sesion del estado real de Firebase Auth. Si hay un usuario
    // admin@ logueado (sesion persistida por Firebase), entra directo sin
    // re-pedir contrasena; si no, se muestra el login. Como este componente
    // envuelve TODAS las rutas /admin (router-view), protege el panel completo.
    this._unsubAuth = firebase.auth().onAuthStateChanged((user) => {
      this.authenticated = !!(
        user && user.email && user.email.split("@")[0] === "admin"
      );
      this.authReady = true;
    });
  },
  beforeDestroy() {
    if (typeof this._unsubAuth === "function") this._unsubAuth();
  },
  methods: {
    getLoginInfo() {
      // Feedback inmediato tras un login exitoso desde Auth.vue
      // (onAuthStateChanged tambien lo reflejaria, esto solo acelera la UI).
      this.authenticated = true;
    }
  }
};
</script>

<style>
.admin {
  background: #639bfa;
  min-height: 100vh;
  overflow-x: hidden;
}

.admin__auth-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 90vh;
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 200;
}

/* CSS Loader styles y Custom CSS */
.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
  position: relative;
  transform: scale(0.55);
}

.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
